import { render, staticRenderFns } from "./MissingTranslation.vue?vue&type=template&id=4aa5c228&scoped=true&"
import script from "./MissingTranslation.vue?vue&type=script&lang=js&"
export * from "./MissingTranslation.vue?vue&type=script&lang=js&"
import style0 from "./MissingTranslation.vue?vue&type=style&index=0&id=4aa5c228&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa5c228",
  null
  
)

export default component.exports